export default "__VITE_ASSET__957935be__"